import styled from 'styled-components';


interface DefaultContainerSummaryPropsPix {
    marginTop?: any;
    marginRight?: any;
    position?: any;
    justifyContent?: any;
    display?: any;
    gap?: any;
}

interface TextSummaryPixProps {
    fontSize?: any;
    fontWeight?: any;
    marginTop?: any;
    color?: any;
    textDecoration?: any;

}

export const DefaultContainer = styled.div`
    display: flex;
`;


export const PixPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: fit-content;
  width: 70%;
  margin: 2.7%;
  background-color: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
`;

export const DefaultTitlePix = styled.span`
    font-size: 18px;
    font-weight: 300;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(128, 126, 128, 1);
`;


export const DefaultSpanListPix = styled.span`
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(66, 66, 66, 1);
    margin-bottom: 8px;
    &:last-child{
        margin-bottom: 0px;
    }
`;

export const DivList = styled.div`
    padding: 0 0 16px 32px;
    display: inline-grid;
`

export const DefaultDivPix = styled.div`
    padding: 0 0 16px 24px
`;

export const DivGrid = styled.div`
    display: grid;
    justify-content: center;
`;

export const SpanQrCode = styled.span`
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
    margin-bottom: 32px;
    margin-top: 16px;
    &:last-child{
        margin-bottom: 0px;
        margin-top: 32px;
    }
`;

export const DivCopyPaste = styled.div`
  border: 1px solid #f58220;
  border-radius: 12px;
  padding: 16px 24px 16px 24px;
  min-height: 75px;
  display: flex;
  align-items: center;
  margin: 16px 24px 16px 24px;
  justify-content: space-around;

`;

export const DivPixCodeNotification = styled.div`
    position: absolute;
    top: 88%;
    right: 30%;
    border: 1px solid #f58220;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 5px;
    background-color: #fff;
`;
export const DivPixQrCode = styled.div`
    display: flex;
    justify-content: center;
    background-color: #fff;
`;

export const TextAreaCopyPaste = styled.textarea`
    width: 100%;
    border: none;
    flex: 1;
    font-size: 11px;
    line-height: 25px;
    color: #1a191a;
    resize: none;
  
`;

export const ButtonCopyPaste = styled.button`
    background-color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    & > svg {
      color: #f58220;
    }

    &:hover {
      svg {
        color: #d36609;
      }
    }
  
`;

export const TextCopyPaste = styled.span`
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
`;

export const SpanWaitingPayment = styled.span<{ color: string, weight: number }>`
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: ${props => props.color};
    font-weight: ${props => props.weight};
    margin-bottom: 8px;
    margin-top: 32px;
    &:last-child{
        margin-bottom: 24px;
        margin-top: 0px;
    }
`;

export const PaymentSummaryPix = styled.div`
    background: #fff;
    width: 30%;
    height: 100vh;
    position: relative;
`;

export const DefaultContainerSummaryPix = styled.div<DefaultContainerSummaryPropsPix>`
    display: ${props => props.display};
    margin-top: ${props => props.marginTop}%;
    margin-right: ${props => props.marginRight}%;
    position: ${props => props.position};
    justify-content: ${props => props.justifyContent};
    padding: 0 0 0 16px;
    gap: ${props => props.gap}px;
`;


export const TitleSummaryPix = styled.span`
    font-size: 18px;
    font-weight: 400;
`;


export const TextSummaryPix = styled.span<TextSummaryPixProps>`
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    margin-top: ${props => props.marginTop}px;
    color: ${props => props.color};
    text-decoration: ${props => props.textDecoration};
    cursor: pointer;
`;

export const TextSummaryPixLink = styled.a<TextSummaryPixProps>`
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    margin-top: ${props => props.marginTop}px;
    color: ${props => props.color};
    cursor: pointer;
`;

export const ModalPix = styled.div`
position: fixed;
    top: 0;
    left: 0;
    background: #00000065;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  p,
  h2 {
    margin: 0;
  }
  display: flex !important;
`;
export const ModalPixContent = styled.div`
  background: #fff;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 32px 16px;
  max-width: 480px;
  max-height: 460px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  overflow-y: auto;
`;
export const ModalPixSuccessMessage = styled.div`
  h2 {
    font-size: 16px;
    color: #807e80;
    text-align: center;
    font-weight: 500;
  }
`;
export const ModalPixIconSuccessMessage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const ModalPixDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export const ModalPixButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;

  button {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    border: none;
    background-color: #f58220;
    color: #fff;
    padding: 14px 20px;
    border-radius: 12px;
    transition: filter 0.2s;

    svg {
      color: #f58220;
      background-color: #fff;
      border-radius: 50%;
    }

    &:hover {
      filter: brightness(0.8);
    }
  }

`;

export const ModalPixContentTitle = styled.h2`
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: #005fae;
`;

export const ModalPixDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid#4D4C4D;
    padding-bottom: 2px;

    h2 {
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      color: #4d4c4d;
    }
`;

export const ModalPixDetailContainerDebt = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4d4c4d;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
`














